import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

const initialState = {
    isDirty: false,
    totalReqCount: 0,
    invoiceDataInStore: {},
    estimateDataInStore: {},
    appointmentDataInStore: {},
    isSettingsDirty: false,
};

const globalStore = (set) => ({
    ...initialState,

    markSaved: (markDirty = true) => {
        set({ isDirty: markDirty ? true : false });
    },

    setTotalReqCount: (count) => {
        set({ totalReqCount: count });
    },

    incrementTotalReqCount: (delta = 1) => {
        set((state) => ({ totalReqCount: (state.totalReqCount || 0) + delta }));
    },

    setInvoiceDataInStore: (data, markDirty = true) => {
        set({ invoiceDataInStore: data, isDirty: markDirty ? true : false });
    },
    resetGlobalState: () => set({ invoiceDataInStore: {}, isDirty: false }),

    setEstimateDataInStore: (data, markDirty = true) => {
        set({ estimateDataInStore: data, isDirty: markDirty ? true : false });
    },
    resetEstimate: () => set({ estimateDataInStore: {}, isDirty: false }),

    setAppointmentDataInStore: (data, markDirty = true) => {
        set({ appointmentDataInStore: data, isDirty: markDirty ? true : false });
    },
    resetAppointment: () => set({ appointmentDataInStore: {}, isDirty: false }),

    resetGlobalState: () => set({ isDirty: false, invoiceDataInStore: {}, estimateDataInStore: {}, appointmentDataInStore: {} }),

    setSettingsDirty: (val) => set({ isSettingsDirty: val }),
    resetSettingsDirty: () => set({ isSettingsDirty: false }),
});

// USE THIS BELOW FUNCTION TO TO STORE DATA ONLY IN STATE AND NOT IN LOCAL STORAGE
// const useGlobalState = create(globalState);

// USE THIS BELOW FUNCTION TO TO STORE DATA IN STATE AND  LOCAL STORAGE BOTH
// THE PRESIST FUNCTION WILL STORE THE STATE IN LOCAL STORAGE
const useGlobalStore = create(
    persist(globalStore, {
        name: 'global-store',
        storage: createJSONStorage(() => localStorage),
        partialize: (state) => ({
            totalReqCount: state.totalReqCount,
        }),
    })
);
export default useGlobalStore;
